/** Shared seat chips — boat lineup, arc seat picker, roster mapping. */

export type SeatChipState = 'default' | 'assigned' | 'selected';

export function uiSeatChip(state: SeatChipState): string {
  const base =
    'min-h-9 min-w-9 rounded-full border px-2 py-1.5 text-xs font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-focus/15 sm:px-3 sm:text-sm';

  switch (state) {
    case 'selected':
      return `${base} border-accent bg-accent text-accent-foreground`;
    case 'assigned':
      return `${base} border-border bg-highlight text-highlight-foreground`;
    default:
      return `${base} border-border bg-surface text-content-secondary hover:bg-surface-muted`;
  }
}

export function uiSeatCard(state: SeatChipState): string {
  const base =
    'relative flex w-full items-center gap-2 px-3 py-2 border-2 rounded-lg transition-all';

  switch (state) {
    case 'selected':
      return `${base} border-accent bg-accent-muted shadow-md ring-2 ring-accent/30`;
    case 'assigned':
      return `${base} border-border bg-surface-muted`;
    default:
      return `${base} border-border bg-surface hover:border-border hover:bg-surface-muted`;
  }
}

export function uiSeatBadge(state: SeatChipState): string {
  const base =
    'flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center font-bold text-xs shadow-sm';

  switch (state) {
    case 'selected':
      return `${base} bg-accent text-accent-foreground`;
    case 'assigned':
      return `${base} bg-highlight text-highlight-foreground`;
    default:
      return `${base} bg-surface-elevated text-content-muted`;
  }
}

export const UI_BOAT_AXIS_LABEL =
  'flex items-center justify-center gap-2 py-1 text-[11px] font-semibold text-content-muted uppercase tracking-wider';
